import { action, extendObservable } from 'mobx';
import { MembershipStore } from 'modules/membership';
import { UiService } from 'modules/ui';

import Store from './ProductStore';

import Request from '@hotmart/request';

class ProductService {
  @action
  setData(data = {}) {
    extendObservable(Store, data);
  }

  @action
  async getProductsByProducer(query = {}) {
    let response = null;

    try {
      response = await Request('product.getProductsByProducer', { ...query });
      this.setData({ products: response.data });
    } catch (error) {
      this.handleError(error);
    } finally {
      Store.loaded = true;
    }

    return response;
  }

  @action
  async getOffers(query = {}) {
    let response = null;

    try {
      const { owner, ...q } = query;
      const method = owner
        ? 'getOffersByProduct'
        : 'getHotlinksByProducerAndProduct';

      response = await Request(`product.${method}`, { ...q });
    } catch (error) {
      this.handleError(error);
    } finally {
      Store.loaded = true;
    }

    return response;
  }

  @action
  async getSelectedProduct() {
    let response = null;
    const productId = MembershipStore.productId;

    if (productId) {
      const query = { id: productId };

      try {
        response = await Request('product.getProductById', { ...query });
      } catch (error) {
        this.handleError(error);
      } finally {
        Store.loaded = true;
      }
    }

    return response;
  }

  handleError() {
    UiService.setAlertError('default_error');
  }
}

export default new ProductService();
